import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Peruuta tilaus',
  title: 'Älä koskaan hylkää kevyin perustein!',
  text: 'Jos tilauksessa on pieni ongelma, soita asiakkaalle ja sovi asia hänen kanssaan.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Tuotteet loppu varastosta',
    [OrderRejectionReason.ClosingSoon]: 'Liike on suljettu',
    [OrderRejectionReason.StoryBusy]: 'Liikkeellä on liian kiire',
    [OrderRejectionReason.CustomerMistake]: 'Asiakas soitti ja perui',
    [OrderRejectionReason.DriverNotArrived]: 'Kuljettaja ei saapunut',
  },
  buttons: {
    confirm: 'Vahvista',
  },
};
